import * as React from 'react';
import { SvgIcon } from '../svg-icon';
import { ButtonLink } from '../../primitives/button/button-link';
import { ButtonStyle } from '../../primitives/button/button';
import { PaymentLabel, AppContentCardModel } from '../../webgiving-generated';
import { Text } from '../../components/text';

import iconDownload from '../../assets/svg/icon-download.svg';
import * as style from './app-store-call-to-action.less';
import { AppContentCard } from '../app-content-card/app-content-card';

export interface AppStoreCallToActionProps {
	mobileAppName: string;
	getAppUrl: string;
	paymentLabel: PaymentLabel;
	hasCustomApp: boolean;
	hasWelcomeSmsBeenSent: boolean;
	appContentCard: AppContentCardModel | null;
}

export const AppStoreCallToAction: React.StatelessComponent<AppStoreCallToActionProps> = (props) => {
	const {mobileAppName, getAppUrl, paymentLabel, hasCustomApp, hasWelcomeSmsBeenSent, appContentCard} = props;
	const introText = hasCustomApp && 'Did you know we have a mobile app? ';
	const outroText = hasWelcomeSmsBeenSent && <span><Text> We have just sent a text to your mobile device with a link to download</Text> <strong>{mobileAppName} <Text>app</Text></strong>.</span>;

	const genericCta = (
		<div>
			<div className={style.downloadIcon}>
				<SvgIcon svg={iconDownload}/>
			</div>
			<div className={style.downloadDescription}>
				<p>
					{introText ? <Text>{introText}</Text>: introText }
					<strong>{mobileAppName} <Text>app</Text></strong> <Text>is your fastest, most convenient way to make a {paymentLabel.NounLowerCase}.</Text>
					{outroText}
				</p>
			</div>
			<div>
				<ButtonLink href={getAppUrl}
					acceptanceTestTargetId="Get app link"
					className="button"
					buttonStyle={ButtonStyle.Ghost}
					openNewTab={true}><Text>Get the app</Text></ButtonLink>
			</div>
		</div>
	);

	return appContentCard ? (
		<AppContentCard appName={mobileAppName}
			cardType={appContentCard.CardType}
			id={appContentCard.Id}
			isFeatured={appContentCard.IsFeatured}
			getAppUrl={getAppUrl}
			title={appContentCard.Title}
			imageUrl={appContentCard.ImageUrl}
			subtitle={appContentCard.Subtitle}
			summary={appContentCard.Summary}
			tabName={appContentCard.TabName}
			eventStartTime={appContentCard.EventStartTime}
			eventEndTime={appContentCard.EventEndTime}
			isAllDayEvent={appContentCard.EventAllDay}
		/>
	) : genericCta;
};
